import React, { useState } from 'react';

type ContactFormProps = {
  onCancel?: () => void;
};

export function ContactForm({ onCancel }: ContactFormProps) {
  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState<string | null>(null);
  const [error, setError] = useState(false);
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    message: '',
    website: '',
  });

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (form.website) return;

    setSending(true);
    setStatus(null);
    setError(false);

    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          phone: form.phone,
          date: form.date,
          message: form.message,
        }),
      });

      const payload = await res.json().catch(() => ({}));
      const success = res.ok && payload.success !== 'false' && payload.success !== false;

      if (!success) {
        throw new Error(
          typeof payload.message === 'string' && payload.message
            ? payload.message
            : 'Failed to send. Please try again.',
        );
      }

      setStatus('Sent! We’ll reply shortly.');
      setForm({ name: '', email: '', phone: '', date: '', message: '', website: '' });
    } catch (err) {
      setError(true);
      setStatus(err instanceof Error ? err.message : 'Something went wrong.');
    } finally {
      setSending(false);
    }
  };

  return (
    <form className="contact-form" onSubmit={onSubmit}>
      <label className="honeypot" aria-hidden="true">
        Website
        <input
          type="text"
          tabIndex={-1}
          autoComplete="off"
          value={form.website}
          onChange={(e) => setForm({ ...form, website: e.target.value })}
        />
      </label>
      <label>
        Name*
        <input
          required
          type="text"
          minLength={2}
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
        />
      </label>
      <label>
        Email*
        <input
          required
          type="email"
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
        />
      </label>
      <label>
        Phone
        <input type="tel" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
      </label>
      <label>
        Event Date
        <input type="date" value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} />
      </label>
      <label>
        Event Details*
        <textarea
          required
          minLength={10}
          rows={4}
          value={form.message}
          onChange={(e) => setForm({ ...form, message: e.target.value })}
          placeholder="Venue, set length, production needs, budget, routing notes..."
        />
      </label>
      <div className="form-actions">
        <button className="primary as-button" type="submit" disabled={sending}>
          {sending ? 'Sending…' : 'Send Inquiry'}
        </button>
        {onCancel && (
          <button className="ghost as-button" type="button" onClick={onCancel}>
            Cancel
          </button>
        )}
      </div>
      {status && <p className={error ? 'status error' : 'status'}>{status}</p>}
    </form>
  );
}
